export default __webpack_public_path__ + "static/media/new-msat-modal-2.07bc2a23.svg";